var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_1290_6142)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 7.99915L20.1172 8.52655V23.8291L20.2764 23.984L27.5589 19.7853L20.2764 7.99915Z",
    fill: "#C1CCF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2905 7.99915L13.0078 19.7853L20.2905 23.984V16.5566V7.99915Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.285 25.3283L20.1953 25.435V30.886L20.285 31.1414L27.572 21.1317L20.285 25.3283Z",
    fill: "#C1CCF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2905 31.1414V25.3283L13.0078 21.1317L20.2905 31.1414Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 23.9835L27.5638 19.7847L20.2812 16.556V23.9835Z",
    fill: "#8197EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0078 19.7847L20.2905 23.9835V16.556L13.0078 19.7847Z",
    fill: "#C1CCF8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_6142",
    x1: 40,
    y1: 40,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#627EEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.4386dd9c6d5e4f1752cbfbb0bf9ade49.svg";
export { ForwardRef as ReactComponent };